module.exports = __webpack_public_path__ + "staticmedia/media/Roboto-Light.303902ba.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/fonts/Roboto-Light.ttf
// module id = 111
// module chunks = 0